import { DataBean } from "../DataBean";

export class MarketPlaceCategory extends DataBean {



    public async getMarketPlaceCategoryCatalog(idMarketPlace: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getMarketPlaceCategoryCatalog_Number", [idMarketPlace]);
    }
    public async deleteMarketPlaceCategory(idMarketPlaceCategory: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteMarketPlaceCategory_Number", [idMarketPlaceCategory]);
    }

}